import React from 'react';
import moment from 'moment';
import { fullDateTime } from 'Consts/DateFormats';
import { getApexInvestigationStatusColor } from 'Consts/Apex';
import { useApexAdminPortalStateContext } from '../../ApexAdminPortalContext';
import View from './View';

const History = () => {
  const { investigationResource } = useApexAdminPortalStateContext();
  const [rows, setRows] = React.useState([]);

  const refreshRows = () => {
    const newRows = investigationResource?.attr('history')?.resources()?.list().map((historyEvent) => {
      const stateChange = historyEvent.selectedOptionPrompt('stateChange');
      return {
        stateChange,
        statusColors: getApexInvestigationStatusColor(historyEvent.attr('stateChange')),
        date: moment(historyEvent.attr('timestamp')).utc().format(fullDateTime),
        comment: historyEvent.attr('comment') || 'N/A',
        user: historyEvent.attr('user'),
      };
    });
    setRows(newRows);
  };

  React.useEffect(() => {
    refreshRows();
  }, [investigationResource]);

  if (!investigationResource) {
    return null;
  }

  return (
    <View
      rows={rows}
    />
  );
};

export default History;
